import {css, StyleSheet} from 'aphrodite';
import React, {useEffect, useState} from 'react';

import {BLUE_DARKER, GREEN} from 'ui-library/Colors';

/** @package */
export const NUM_BARS = 6;
const BAR_WIDTH = 5; // px
const BAR_MIN_HEIGHT = 10; // px
const BAR_MAX_HEIGHT = 50; // px
const BAR_ANIMATION_LENGTH = 500; // ms

const BAR_COLORS = [GREEN, BLUE_DARKER];

function generateBarHeight(): Array<number> {
  return Array.from(
    {length: NUM_BARS},
    () => BAR_MIN_HEIGHT + (BAR_MAX_HEIGHT - BAR_MIN_HEIGHT) * Math.random()
  );
}

export default function AnalysisRunningAnimation(): JSX.Element {
  const [heights, setHeights] = useState(generateBarHeight());

  useEffect(() => {
    const interval = setInterval(() => {
      setHeights(generateBarHeight());
    }, BAR_ANIMATION_LENGTH);
    return () => {
      clearInterval(interval);
    };
  });

  return (
    <div role="img" aria-label="Loading animation" className={css(styles.rectanglesWrapper)}>
      {heights.map((barHeight, i) => (
        <div
          className={css(styles.animatedRectangle)}
          style={{
            height: barHeight,
            backgroundColor: BAR_COLORS[i % BAR_COLORS.length],
          }}
          key={i}
        />
      ))}
    </div>
  );
}

const styles = StyleSheet.create({
  rectanglesWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    height: BAR_MAX_HEIGHT,
  },
  animatedRectangle: {
    width: BAR_WIDTH,
    marginRight: BAR_WIDTH,
    transitionProperty: 'height, transform',
    transitionDuration: `${BAR_ANIMATION_LENGTH}ms`,
    transitionTimingFunction: 'ease',
    borderRadius: '1px 1px 0px 0px',
  },
});
